import { numberMoney } from 'Data/format.js'
import { LEDGER_ENTRY_TYPE } from 'Data/payments.js'

export function getAmount(entry) {
  switch (entry.type) {
    case LEDGER_ENTRY_TYPE.CHARGE:
    case LEDGER_ENTRY_TYPE.ADJUSTMENT:
      return numberMoney(
        entry.transactions.reduce((acc, e) => acc + e.amount, 0)
      )
    case LEDGER_ENTRY_TYPE.INSTALLMENT_CHARGE:
    case LEDGER_ENTRY_TYPE.CHARGE_TRANSFER:
    case LEDGER_ENTRY_TYPE.TRANSFER_CHARGE:
    case LEDGER_ENTRY_TYPE.APPLIED_PAYMENT:
    case LEDGER_ENTRY_TYPE.UNAPPLIED_PAYMENT:
    case LEDGER_ENTRY_TYPE.PAYMENT_PLAN:
    case LEDGER_ENTRY_TYPE.PAYMENT_PLAN_ROLLBACK:
    case LEDGER_ENTRY_TYPE.PAYMENT_CORRECTION:
    case LEDGER_ENTRY_TYPE.REFUND:
    case LEDGER_ENTRY_TYPE.TRANSFER_CREDIT:
      return numberMoney(entry.transaction.amount)
    case LEDGER_ENTRY_TYPE.PAYMENT:
      return numberMoney(entry.payment.amount)
    case LEDGER_ENTRY_TYPE.NOTE:
    default:
      return '-'
  }
}
